import React, { useRef, useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import isObject from 'lodash/isObject'

import { useDialog } from '@galo-monitor/dialog'
import I18n, { useT } from '@galo-monitor/i18n'
import { AuthenticationActions } from '@galo-monitor/stores/authentication'
import { selectAuthError } from '@galo-monitor/stores/authentication/selectorAuthentication'
import LoginForm from '@galo-monitor/web-containers/forms/auth/LoginForm'
import { Item, ForgotButton } from '@galo-monitor/web-containers/layouts/GuestLayout/theme'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'
import { useRoutes } from '@galo-monitor/web-containers/routes/guest'

const LoginScreen = () => {
  const formRef = useRef(null)

  const dispatch = useCallback(useDispatch())
  const authError = useSelector(selectAuthError)

  const { createDialog } = useDialog()
  const t = useT()

  const { routes } = useRoutes()

  useEffect(
    () => {
      dispatch(AuthenticationActions.resetAuthentication())
    },
    [dispatch]
  )

  useEffect(
    () => {
      if (isObject(authError) && authError.type === 'logout') {
        createDialog({
          id: 'login-error',
          Component: ErrorModal,
          props: {
            title: t('unexpected error occurred'),
            message: authError.message
          }
        })
      }
    },
    [authError, createDialog, t]
  )

  return (
    <Item>
      <LoginForm ref={ formRef } />

      <ForgotButton>
        <Link to={ routes.forgotPassword.path }>
          <I18n>I forgot my password</I18n>
        </Link>
      </ForgotButton>
    </Item>
  )
}

export default LoginScreen
